import React, { useState } from "react";
import arrowleft from "../assets/images/arrow-left.png";
import { Link, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";

import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import { Formik } from "formik";

import http from "../services/http";
import GetStorage from "../services/Storage";

export default function AdvancedSecuritySettings(props) {
  console.log("props ha ", props);
  const [showModal, setShow] = useState(false);
  const [message, setMessage] = useState("");

  const params = useParams();
  const email = params.name;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const token = GetStorage.get("xAuthToken");
  const [toggle, setToggle] = useState(true);

  const initialValues = {
    pin: "",
  };

  const onSubmit = async (values, { resetForm }) => {
    http
      .put(`api/admin/coach?token=${token}`, {
        email: email,
        pin: values.pin,
      })
      .then((res) => {
        console.log("response", res.data);
        resetForm();
        setMessage(res.data.message);
      })
      .catch((error) => {});
  };
  return (
    <>
      <body>
        <div className="wrapper">
          <Nav
          // sidebarClass={toggle ? "show" : "hide"}
          />

          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  {/*  <button
                    onClick={() => setToggle(!toggle)}
                    type="button"
                    className="btn btn-link  "
                  >
                    {" "}
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button> */}
                  <h1>Advance Security Settings</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>
            <div className="dashbord_content">
              <div className="dashobord_inner new_team_add">
                <Formik initialValues={initialValues} onSubmit={onSubmit}>
                  {({ values, handleChange, handleBlur, handleSubmit }) => (
                    <>
                      <form>
                        <div className="row">
                          <div className="col-lg-6 col-md-8 12">
                            <div className="col-12">
                              <div className="fomr-group">
                                <input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  value={email}
                                />
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="fomr-group">
                                <input
                                  onChange={handleChange("pin")}
                                  onBlur={handleBlur("pin")}
                                  value={values.pin}
                                  className="custom_input form-control"
                                />
                              </div>
                            </div>
                            <h2>{message}</h2>

                            <div className="col-12 d-flex justify-content-start">
                              <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                                <button
                                  type="button"
                                  className=" them_btn_ouline  "
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={handleSubmit}
                                  type="button"
                                  className="them_btn "
                                  data-toggle="modal"
                                  data-target="#new_team_add_yes"
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </>
                  )}
                </Formik>
              </div>
            </div>
            <Modal show={showModal} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Are you sure?</Modal.Title>
                <button
                  onClick={handleClose}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="true">&times;</span>{" "}
                </button>
              </Modal.Header>
              <Modal.Body>
                <div className="modal-body">
                  <div className="raing_star">
                    <p>
                      Are you sure you want to change <b>John Doe's</b> PIN.
                      This action can be undone in settings.{" "}
                    </p>
                    {/* <div className="row mt-3">
                      <div className="col-12">
                        <div className="fomr-group">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email ID"
                          />{" "}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="fomr-group">
                          <input
                            type="Password"
                            className="form-control"
                            placeholder="Password"
                          />{" "}
                        </div>
                      </div>
                    </div> */}
                    <div className="modal-footer border-top-0">
                      <button type="button" className="them_btn">
                        No
                      </button>
                      <Link to="/teamShark">
                        <button type="button" className="them_btn ">
                          Yes
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>

        <div
          className="modal fade starrating new_team_add"
          id="new_team_add_yes"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="new_team_add_yes"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="new_team_add_yes">
                  Are you sure?
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="true">&times;</span>{" "}
                </button>
              </div>
              <div className="modal-body">
                <div className="raing_star">
                  <p>
                    Are you sure you want to change <b>John Doe's</b> PIN. This
                    action can be undone in settings.{" "}
                  </p>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="fomr-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email ID"
                        />{" "}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="fomr-group">
                        <input
                          type="Password"
                          className="form-control"
                          placeholder="Password"
                        />{" "}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer border-top-0">
                    <button type="button" className="them_btn_ouline ">
                      No
                    </button>
                    <button type="button" className="them_btn ">
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}
